import * as React from 'react';
import {
  BankOutlined,
  FunnelPlotOutlined,
  BuildOutlined,
  ApiOutlined,
  CreditCardOutlined,
  HistoryOutlined,
  DatabaseOutlined,
  SettingOutlined,
  DeploymentUnitOutlined,
  UserOutlined,
  FileDoneOutlined,
  CloudServerOutlined,
  BookOutlined,
  FileTextOutlined,
  PartitionOutlined,
  AppstoreAddOutlined,
  FileSyncOutlined,
  TeamOutlined,
  RobotOutlined
} from '@ant-design/icons';
import {
  UserContextProps,
  AgentContextProps,
  AgentContext,
  UserContext,
  ProviderType,
  OrgContext,
  OrgContextProps
} from '@interface/index';
import { Link } from 'react-router-dom';
import { NiMenu } from '@component/index';
import { localizedString } from '@locale/index';
import {
  OrgPermission,
  ORG_OPERATION,
  AgentPermission,
  AGENT_OPERATION
} from '@permission/index';
import {
  getOrgId,
  getAgentId,
  isStructAgent,
  isProviderAgent,
  getAgentPathPrefix,
  isLanguageAgent,
  isBotAgent,
  getOrgName,
  PathKeys,
  PathKeyRegxMap,
  isOrgOwner,
  isModuleImplementationAgent,
  isPostgresProviderAgent
} from '@lib/index';
import { Menu } from 'antd';
import { AGENT_DEPLOY_MODE, AGENT_MODE } from '@config/constants';

const logo = require('@static/image/logo.png');
const logoIcon = require('@static/image/logo-icon.png');

export interface ISidebarProps {
  openKeys: string[];
  collapsed: boolean;
  history: any;
  $user: UserContextProps;
  $org: OrgContextProps;
  $agent: AgentContextProps;
}

export interface ISidebarState {
  selectedKeys: string[];
}

class SidebarComp extends React.Component<ISidebarProps, ISidebarState> {
  state: ISidebarState = {
    selectedKeys: []
  };
  unListen: any;

  componentDidMount() {
    const listenSelectedKeys = () => {
      if (location.pathname) {
        this.selectKey(location.pathname, location.search);
      }
    };

    listenSelectedKeys();

    this.unListen = this.props.history.listen(() => {
      listenSelectedKeys();
    });
  }

  componentWillUnmount() {
    this.unListen();
  }


  render() {
    const { collapsed, $agent, $user, $org } = this.props;
    const { selectedKeys } = this.state;

    return (
      <div className="admin-sidebar" >
        {/* <div className="sidebar-logo" key="logo">
          <Link to="/">
            {collapsed ? (
              <img className="logo-icon-img" src={logoIcon} />
            ) : (
              <img className="logo-img" src={logo} />
            )}
          </Link>
        </div> */}
        <NiMenu
          style={{ paddingTop: 20 }}
          className="admin-NiMenu"
          theme={'light'}
          selectedKeys={selectedKeys}
          mode="inline"
          inlineIndent={48}
        >
          {getAgentId() && [
            ...((this.isAgentSettingPage() || isProviderAgent() || isModuleImplementationAgent()) ? this.agentSettingItems() : []),
          ]
          }
          {/* {getAgentId() && [
            ...(this.isAgentOperationPage() ? this.agentOperationItems() : []),
          ]
          } */}
          {getOrgId() && !getAgentId() &&
            [
              <NiMenu.Item key={PathKeys.OrgSetting} className="bold">
                <Link to={`/org/${getOrgName()}`}>
                  <SettingOutlined />
                  <span>{localizedString('org_setting_general', undefined, 'General')}</span>
                </Link>
              </NiMenu.Item>,
              isOrgOwner() &&
              // && window.localStorage.getItem('dev') === 'true' &&
              <NiMenu.Item key={PathKeys.OrgSettingBilling} className="bold">
                <Link to={`/org/${getOrgName()}/billing`}>
                  <CreditCardOutlined />
                  <span>{localizedString('org_setting_billing', undefined, 'Billing')}</span>
                </Link>
              </NiMenu.Item> || undefined,
              // isOrgOwner() && <NiMenu.Item key={PathKeys.OrgSettingCopilot} className="bold">
              //   <Link to={`/org/${getOrgName()}/copilot`}>
              //     <RobotOutlined />
              //     <span>{localizedString('org_setting_copilot', undefined, 'Copilot')}</span>
              //   </Link>
              // </NiMenu.Item> || undefined
            ]
          }
          {$user.user && !$org.org &&
            [
              <NiMenu.Item key={PathKeys.Account} className="bold">
                <Link to="/account">
                  <UserOutlined />
                  <span>{localizedString('user_profile')}</span>
                </Link>
              </NiMenu.Item>,
              <NiMenu.Item key={PathKeys.OrgList} className="bold">
                <Link to="/org">
                  <BankOutlined />
                  <span>{localizedString('sidebar_org')}</span>
                </Link>
              </NiMenu.Item>
            ]
          }

        </NiMenu>
      </div>
    );
  }

  dialogInteractionComp = () => {
    const { $org, $agent } = this.props;
    const orgId = $org.org && $org.org.id;
    const agentId = $agent.agent && $agent.agent.id;

    return [
      $agent.agent && $agent.agent.isService &&
      <NiMenu.Item key={PathKeys.ServiceSchema} className="bold">
        <Link to={`${getAgentPathPrefix()}/service_schema`}>
          <ApiOutlined />
          <span>{localizedString('sidebar_service_schema')}</span>
        </Link>
      </NiMenu.Item>,
      !isProviderAgent() && <NiMenu.Item key={PathKeys.FAKE_TYPES} className="bold">
        <Link to={`${getAgentPathPrefix()}/type`}>
          <BuildOutlined />
          <span>{localizedString('fake_types')}</span>
        </Link>
      </NiMenu.Item> || undefined,
      // !isProviderAgent() && <NiMenu.Item key={PathKeys.Intents} className="bold">
      //   <Link to={`${getAgentPathPrefix()}/intent`}>
      //     <FileTextOutlined />
      //     <span>{localizedString('sidebar_intent')}</span>
      //   </Link>
      // </NiMenu.Item> || undefined,
      // <NiMenu.Item key={PathKeys.Composites} className="bold">
      //   <Link to={`${getAgentPathPrefix()}/frame`}>
      //     <PartitionOutlined />
      //     <span>{localizedString('sidebar_composite')}</span>
      //   </Link>
      // </NiMenu.Item>,
      // <NiMenu.Item key={PathKeys.Entities} className="bold">
      //   <Link to={`${getAgentPathPrefix()}/entity`}>
      //     <AppstoreAddOutlined />
      //     <span>{localizedString('sidebar_entity')}</span>
      //   </Link>
      // </NiMenu.Item>,
      // !isProviderAgent() && <NiMenu.Item key={PathKeys.DialogActs} className="bold">
      //   <Link to={`${getAgentPathPrefix()}/dialog_act`}>
      //     <ContainerOutlined />
      //     <span>{localizedString('dialog_acts')}</span>
      //   </Link>
      // </NiMenu.Item> || undefined,

      <NiMenu.Item key={PathKeys.Libraries} className="bold">
        <Link to={`${getAgentPathPrefix()}/library`}>
          { /*<DownloadOutlined /> */}
          <FileSyncOutlined />
          <span>{localizedString('agent_libraries')}</span>
        </Link>
      </NiMenu.Item>,
      <NiMenu.Divider key={'interaction-divider'} />
    ];
  };

  isAgentSettingPage = () => {
    const path = window.location.pathname;
    const v = [PathKeyRegxMap[PathKeys.AgentSetting], PathKeyRegxMap[PathKeys.OperateSetting]];

    if (Array.isArray(v)) {
      for (const regex of v) {
        const ret = path.match(regex as any);
        if (ret && ret.length && ret[0] === path) {
          return true;
        }
      }
    } else {
      const ret = path.match(v);
      if (ret && ret.length && ret[0] === path) {
        return true;
      }
    }

    return false;
  }

  isAgentOperationPage = () => {
    const path = window.location.pathname;
    const v = [PathKeyRegxMap[PathKeys.AgentDeploy], PathKeyRegxMap[PathKeys.OperateSetting]];

    if (Array.isArray(v)) {
      for (const regex of v) {
        const ret = path.match(regex as any);
        if (ret && ret.length && ret[0] === path) {
          return true;
        }
      }
    } else {
      const ret = path.match(v);
      if (ret && ret.length && ret[0] === path) {
        return true;
      }
    }

    return false;
  }

  agentSettingItems = () => {
    const { $org, $agent } = this.props;
    const orgId = $org.org && $org.org.id;
    const agentId = $agent.agent && $agent.agent.id;

    return [
      <NiMenu.Item key="general" className="bold">
        <Link to={`${getAgentPathPrefix()}/${this.isAgentOperationPage() ? 'operate_setting' : 'setting'}?tab=general`}>
          <SettingOutlined />
          <span>{localizedString('agent_tab_basic_info')}</span>
        </Link>
      </NiMenu.Item>,
      isBotAgent() && <NiMenu.Item key="integration" className="bold">
        <Link to={`${getAgentPathPrefix()}/${this.isAgentOperationPage() ? 'operate_setting' : 'setting'}?tab=integration`}>
          <AppstoreAddOutlined />
          <span>{localizedString('integration')}</span>
        </Link>
      </NiMenu.Item> || undefined,
      <NiMenu.Item key="access" className="bold">
        <Link to={`${getAgentPathPrefix()}/${this.isAgentOperationPage() ? 'operate_setting' : 'setting'}?tab=access`}>
          { /*<DownloadOutlined /> */}
          <TeamOutlined />
          <span>{localizedString('agent_tab_access')}</span>
        </Link>
      </NiMenu.Item>,
      this.isAgentSettingPage() && $agent.agent && $agent.agent.mode === AGENT_MODE.KNOWLEDGE && <NiMenu.Item key="configuration" className="bold">
        <Link to={`${getAgentPathPrefix()}/${this.isAgentOperationPage() ? 'operate_setting' : 'setting'}?tab=configuration`}>
          <SettingOutlined />
          <span>{localizedString('agent_tab_configuration')}</span>
        </Link>
      </NiMenu.Item> || undefined,
      isBotAgent() && !this.isAgentOperationPage() && <NiMenu.Item key="routing" className="bold">
        <Link to={`${getAgentPathPrefix()}/${this.isAgentOperationPage() ? 'operate_setting' : 'setting'}?tab=routing`}>
          { /*<DownloadOutlined /> */}
          <FunnelPlotOutlined />
          <span>{localizedString('routing_list')}</span>
        </Link>
      </NiMenu.Item> || undefined,
      // $agent.agent && $agent.agent.mode === AGENT_MODE.APPLICATION &&
      // $agent.agent.deployMode === AGENT_DEPLOY_MODE.FRAMELY &&
      // <NiMenu.Item key="backoffice" className="bold">
      //   <Link to={`${getAgentPathPrefix()}/setting?tab=backoffice`}>
      //     { /*<DownloadOutlined /> */}
      //     <FunnelPlotOutlined />
      //     <span>{localizedString('backoffice')}</span>
      //   </Link>
      // </NiMenu.Item> || undefined,
      (isProviderAgent() || isModuleImplementationAgent()) && !this.isAgentOperationPage() && <NiMenu.Item
        key={PathKeys.ProviderConnection}
        className="bold"
      >
        <Link to={`${getAgentPathPrefix()}/provider_connection`}>
          <CloudServerOutlined />
          <span>{localizedString('provider_connection')}</span>
        </Link>
      </NiMenu.Item>,
    ];
  };

  agentOperationItems = () => {
    const { $org, $agent } = this.props;
    const orgId = $org.org && $org.org.id;
    const agentId = $agent.agent && $agent.agent.id;

    return [
      <NiMenu.Item key="deploy" className="bold">
        <Link to={`${getAgentPathPrefix()}/operation?tab=deploy`}>
          <DeploymentUnitOutlined />
          <span>{localizedString('operation_deploy')}</span>
        </Link>
      </NiMenu.Item>,
      // <NiMenu.Item key="log" className="bold">
      //   <Link to={`${getAgentPathPrefix()}/operation?tab=log`}>
      //     <HistoryOutlined />
      //     <span>{localizedString('operation_logs')}</span>
      //   </Link>
      // </NiMenu.Item>
    ];
  };

  selectKey = (path: string, search: string) => {

    if (this.isAgentSettingPage()) {

      if (path.endsWith('provider_connection')) {
        this.setState({ selectedKeys: [PathKeys.ProviderConnection] });
        return;
      }

      const params = new URLSearchParams(search);
      const tab = params.get('tab') || 'general';
      this.setState({ selectedKeys: [tab] });
      return;
    }

    if (this.isAgentOperationPage()) {

      const params = new URLSearchParams(search);
      const tab = params.get('tab') || 'deploy';
      this.setState({ selectedKeys: [tab] });
      return;
    }

    for (const [k, v] of Object.entries(PathKeyRegxMap)) {
      if (Array.isArray(v)) {
        for (const regex of v) {
          if (this.matchPath(path, regex)) {
            this.setState({
              selectedKeys: [k]
            });
            return;
          }
        }
      } else {
        if (this.matchPath(path, v)) {
          this.setState({
            selectedKeys: [k]
          });
          break;
        }
      }
    }
  }

  matchPath = (path: string, regex: RegExp) => {
    const ret = path.match(regex);
    return ret && ret.length && ret[0] === path;
  }
}

export const Sidebar = (props: any) => (
  <AgentContext.Consumer>
    {($agent: AgentContextProps) => (
      <OrgContext.Consumer>
        {($org: OrgContextProps) =>
          <UserContext.Consumer>
            {($user: UserContextProps) => (
              <SidebarComp {...props} $user={$user} $org={$org} $agent={$agent} />
            )}
          </UserContext.Consumer>}
      </OrgContext.Consumer>
    )}
  </AgentContext.Consumer>
);
